import { render, staticRenderFns } from "./flag.vue?vue&type=template&id=09d57f02&scoped=true&"
import script from "./flag.vue?vue&type=script&lang=js&"
export * from "./flag.vue?vue&type=script&lang=js&"
import style0 from "./flag.vue?vue&type=style&index=0&id=09d57f02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d57f02",
  null
  
)

export default component.exports